





































# import settings from '@/settings'
import oncall_duties_table from '@/components/tables/oncall_duties_table'
import af from '@/utils/authorized_formats'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'company_oncall_duties'

    components: { oncall_duties_table }

    data: ()->
        reload: true
        errors: {}
        active_names: [1]
        max_filesize: af['oncall_duty']['file']['max_filesize']/1024/1024
        authorized_formats: af['oncall_duty']['file']['authorized_formats']
        oncall_duty: {
            file_data: ''
            file_name: ''
        }

    computed:
        toggle_collapse_text: ()->
            text = "Ajouter un tableau des astreintes"
            if @active_names.length > 1
                text = "Fermer"
            return text

        toggle_collapse_icon: ()->
            class_icon = 'mdi-plus-circle-o'
            if @active_names.length > 1
                class_icon = 'mdi-close-circle-o'
            return class_icon

    methods:
        has_access_right: t.has_access_right

        reset_oncall_duty: ()->
            oncall_duty: {
                file_data: ''
                file_name: ''
            }
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        collapse_change: (value)->
            # console.log "VUE TOGGLE ", value
            @errors = {}
            @reset_oncall_duty()
            @$refs.oncall_duty_upload.clearFiles()
            return

        handle_file_remove: (file, fileList)->
            @$refs.oncall_duty_upload.clearFiles()
            @oncall_duty.file_data = ''
            @oncall_duty.file_name = ''
            return

        handle_file_change: (file, fileList)->
            is_good_ext = file.raw.type in af['oncall_duty']['file']['mime_types']
            is_good_size = file.size < af['oncall_duty']['file']['max_filesize']

            if !is_good_ext
                n.file_error('Erreur', 'Le fichier doit être de type '+@authorized_formats+'.')
                fileList.pop()
                return
            if !is_good_size
                n.file_error('Erreur', 'Le fichier ne peut pas excéder '+@max_filesize+'Mo.')
                fileList.pop()
                return

            self = @
            if fileList.length > 1
                fileList.splice(0,1)
            reader = new FileReader()
            reader.onload = (e)->
                # console.log 'E', e
                self.oncall_duty.file_data = e.target.result
                self.oncall_duty.file_name = file.name
            reader.readAsDataURL(file.raw)
            # console.log "FILE", @oncall_duty
            return

        delete_oncall_duty: (oncall_duty_uid)->
            # console.log  "DELETE ONCALL DUTY", oncall_duty_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce tableau des astreintes ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "ONCALL DUTY DELETE", oncall_duty_uid
                    m.run('delete_object', ['oncall_duty', oncall_duty_uid])
                    .then (resp)->
                        # console.log "DELETE ONCALL DUTY", resp.body.data.oncall_duty_deletion
                        if resp.body.data.oncall_duty_deletion.ok
                            n.success()
                            self.reload = !self.reload
                        else
                            n.gql_error("company_oncall_duties: delete_oncall_duty: then", resp.body.data.oncall_duty_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "company_oncall_duties: delete_oncall_duty()")
                .catch (cancel)->
                    return

        save: ()->
            # console.log "SAVE ONCALL DUTY", @oncall_duty
            self = @
            m.run('save_oncall_duty', [@oncall_duty])
            .then (resp)->
                if resp.body.data.oncall_duty_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.oncall_duty_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.oncall_duty_form_mutation.errors
                    self.errors = resp.body.data.oncall_duty_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    self.reset_oncall_duty()
                    self.active_names = [1]
                    self.$refs.oncall_duty_upload.clearFiles()
                    self.reload = !self.reload
            .catch (resp)->
                n.catch_error(resp, "company_oncall_duties: save()")

    # mounted: ()->
}
